module.exports = __webpack_public_path__ + "img/icon-home-re-05.b7de81a0.jpg";